module.exports = __webpack_public_path__ + "img/248.c680ad15.jpg";